import loadable from '@loadable/component';

export const ActionsCentersLoadable = loadable(() => import('./ActionsCenters'), { ssr: false });
